import { makeActionCreator } from '../../config/store/utils'

export const SHOW_QUOTE_REQUEST_PUBLISHED_ERROR_DIALOG = 'SHOW_QUOTE_REQUEST_PUBLISHED_ERROR_DIALOG'
export const onOpenQuoteRequestPublishedErrorDialog = makeActionCreator(SHOW_QUOTE_REQUEST_PUBLISHED_ERROR_DIALOG, {})

export const CLOSE_QUOTE_REQUEST_PUBLISHED_ERROR_DIALOG = 'CLOSE_QUOTE_REQUEST_PUBLISHED_ERROR_DIALOG'
export const onCloseQuoteRequestPublishedErrorDialog = makeActionCreator(CLOSE_QUOTE_REQUEST_PUBLISHED_ERROR_DIALOG, {})
